import { logsService } from '@/services'
import logger from '@/logger/index'

// Função para lidar com erros
export function handleRequestError (error, reject) {
  const response = error.response
  logError(response || error)

  const responseData = response && response.data
  const publicError = responseData && typeof responseData === 'object'
    ? responseData
    : error
  if (reject) {
    reject(publicError)
  } else {
    // para try/catch
    throw publicError
  }
}
// Função interna para centralizar o log
function logError (error) {
  logger.error('API Error:', error)
  logsService.logs({ error }) // Envia log para a API
}
